/**
 * @fileoverview POST handler for the "/apps/:app_group_id/messaging_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdMessagingRulesCacheKeys } from "./constants";
import type { PostAppsAppGroupIdMessagingRulesProps, PostMessagingRulesResponse } from "./types";

export const postAppsAppGroupIdMessagingRules = reactQueryMutationAdapter(
  appsAppGroupIdMessagingRulesCacheKeys,
  ({
    appGroupId,
    messagingRules,
    deletedMessagingRuleIds,
  }: PostAppsAppGroupIdMessagingRulesProps): Promise<PostMessagingRulesResponse> => {
    const messagingRulesParams = messagingRules.map((rule) => ({
      id: rule.id,
      name: rule.name,
      object_type: rule.objectType,
      approval_developer_ids: rule.approvalDeveloperIds,
      reachable_threshold: rule.reachableThreshold,
      allow_launch_with_approval: rule.allowLaunchWithApproval,
    }));
    return fetch(
      `/apps/${appGroupId}/messaging_rules`,
      "POST",
      {
        messaging_rules: messagingRulesParams,
        deleted_messaging_rule_ids: deletedMessagingRuleIds,
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
